import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PipesModule } from '@app/shared/pipes/pipes.module';
import { WucPictureModule } from '@inshared/website-ui-components';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { CarouselModule } from 'outshared-lib';
import { CardModule } from '../card/card.module';
import { KnowledgeBaseCarouselComponent } from './knowledge-base-carousel.component';

@NgModule({
    imports: [
        CommonModule,
        CarouselModule,
        RouterModule,
        CardModule,
        LazyLoadImageModule,
        PipesModule,
        WucPictureModule,
    ],
    declarations: [
        KnowledgeBaseCarouselComponent,
    ],
    exports: [
        KnowledgeBaseCarouselComponent,
    ],
})
export class KnowledgeBaseCarouselModule {
}
